import axios from "axios";
import { FirmwareType } from "../../pages/firmware/typings";
const REACT_APP_ADMIN_API = process.env.REACT_APP_ADMIN_API;
const REACT_APP_VEHICLES_API = process.env.REACT_APP_VEHICLES_API;
const { CancelToken } = axios;
const source = CancelToken.source();

export enum FirmwareFilters {
  Version = "filter_version",
  HardwareType = "filter_hardware_type",
  FirmwareType = "filter_firmware_type",
  Description = "filter_description",
  CreatedAt = "filter_created_at",
  Tags = "filter_tags",
  Customer = "filter_customer",
}

export const getFirmwares = async (
  query: string,
  page: number,
  cancelToken = source.token,
  filterBy: string = "",
  sortBy: string = "",
  count: number = 100,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];

  let url = `${REACT_APP_ADMIN_API}/api/firmwares?results_per_page=${count}&q=${query}&page=${page}`;
  if (sortBy !== "") {
    url = `${url}&order=${sortBy}`;
  }
  if (filterBy !== "") {
    url = `${url}&${filterBy}&exclude_contents=1`;
  }

  try {
    const response = await axios({
      method: "get",
      url,
      headers: { Authorization: `Bearer ${token}` },
      cancelToken,
    });
    return { data: response.data, hasNextPage: response.data.has_next_page };
  } catch (e) {
    return e;
  }
};

export const getFirmware = async (id) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const region = localStorage.getItem("region");
  try {
    const response = await axios({
      method: "get",
      url: `${REACT_APP_ADMIN_API}/api/firmwares/${id}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: response.data, hasNextPage: response.data.has_next_page };
  } catch (e) {
    return e;
  }
};

export const createFirmware = async ({
  hardwareType,
  version,
  contentsBase64,
  firmwareType,
  description,
  tags,
  allowed_customers,
}: FirmwareType) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "post",
      url: `${REACT_APP_ADMIN_API}/api/firmwares`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        hardware_type: hardwareType,
        version,
        firmware_type: firmwareType,
        contents_base64: contentsBase64,
        tags,
        description,
        allowed_customers,
      },
    });
    return { data: response };
  } catch (e) {
    return { detail: e.response.data.error };
  }
};

export const deleteFirmware = async (id: string) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "delete",
      url: `${REACT_APP_ADMIN_API}/api/firmwares/${id}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: response };
  } catch (e) {
    return { error: e.response.data.error };
  }
};

export const loadFirmwareToDevices = async (imeis: string[], id: number) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "post",
      url: `${REACT_APP_ADMIN_API}/api/firmwares/${id}/load`,
      headers: { Authorization: `Bearer ${token}` },
      data: imeis,
    });
    return { data: response };
  } catch (e) {
    return { detail: e.response.data.error };
  }
};

export const getFirmwareVersion = async (imeis: string[]) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "post",
      url: `${REACT_APP_ADMIN_API}/api/device/version`,
      headers: { Authorization: `Bearer ${token}` },
      data: { imeis: imeis },
    });
    return { data: response.data, hasNextPage: response.data.has_next_page };
  } catch (e) {
    return e;
  }
};

export const cancelFirmwareUpdate = async (imeis) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "post",
      url: `${REACT_APP_ADMIN_API}/api/firmwares/cancel`,
      headers: { Authorization: `Bearer ${token}` },
      data: imeis,
    });
    return { data: response };
  } catch (e) {
    return { detail: e.response.data.error };
  }
};

export const editFirmware = async ({
  id,
  hardwareType,
  version,
  contentsBase64,
  firmwareType,
  description,
  tags,
  allowed_customers,
}: FirmwareType) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "patch",
      url: `${REACT_APP_ADMIN_API}/api/firmwares/${id}`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        hardware_type: hardwareType,
        version,
        firmware_type: firmwareType,
        contents_base64: contentsBase64,
        tags,
        description,
        allowed_customers,
      },
    });
    return { data: response };
  } catch (e) {
    return { detail: e.response.data.error };
  }
};
